import { render } from "./StepRiepilogo.vue?vue&type=template&id=6992c535&scoped=true"
import script from "./StepRiepilogo.vue?vue&type=script&lang=js"
export * from "./StepRiepilogo.vue?vue&type=script&lang=js"

import "./StepRiepilogo.vue?vue&type=style&index=0&id=6992c535&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6992c535"]])

export default __exports__